import { createElement, FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { LogicalFormValues } from '@components/EntityDrawers/drawers/Logical/form';
import Advanced from '@components/EntityDrawers/drawers/Logical/tabs/Advanced';
import Standard from '@components/EntityDrawers/drawers/Logical/tabs/Standard';
import { DrawerContentProps } from '@components/EntityDrawers/hocs/withDrawer';
import { TimeLineDateError } from '@constants/validation';
import useTwoDatesValidation from '@hooks/useTwoDatesValidation';

export const LogicalContent: FC<DrawerContentProps> = ({ tab }) => {
  const form = useFormContext<LogicalFormValues>();

  useTwoDatesValidation({
    form,
    startKeyName: 'timelineStartDate',
    endKeyName: 'timelineEndDate',
    error: () => TimeLineDateError,
  });

  return createElement([Standard, Advanced][tab ?? 0]);
};
